import React from 'react';
import { FaAngleDoubleUp, FaAngleDoubleDown } from 'react-icons/fa';
import './SectionFooter.css';

interface PropsInterface {
  isCollapsed: boolean;
  isCollapsible: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}

const SectionFooter: React.FC<PropsInterface> = ({
  isCollapsed,
  setIsCollapsed,
  isCollapsible,
}) => {
  if (!isCollapsible) {
    return null;
  }

  const className = `SectionFooter ${isCollapsed ? 'collapsed' : 'open'}`;

  return (
    <button
      type='button'
      className={ className }
      onClick={ () => setIsCollapsed(!isCollapsed) }
      aria-expanded={ !isCollapsed }
      aria-label={ isCollapsed ? 'Expand section' : 'Collapse section' }
    >
      <span className='iconWrapper'>
        {isCollapsed ? <FaAngleDoubleDown /> : <FaAngleDoubleUp />}
      </span>
    </button>
  );
};

export default SectionFooter;
